import dayjs from "dayjs";

export const CheckInOutJson = {
    screenTitle: "Attendance Management",
    fieldMeta: [
        {
            label: "From Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "fromDate",
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "toDate-le",
            maxDate: dayjs(),
            isMAxDate: true,
        },
        {
            label: "To Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "toDate",
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "fromDate-ge",
            maxDate: dayjs(),
            isMAxDate: true,
        },

        {
            label: "Sales Team",
            controlType: "autocomplete",
            placeHolder: "Select Sales Team",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 6,
            masterName: "salesPersonDetail",
            dataKey: "salesTeamId",
            isRootLevelKey: true,
            isMandatory: true,
        },
    ],
};
